import { EnumOption } from "./enum-option"

export const MatterReceiptType = {
  USCISReceiptNumber: 0,
  JVisaApplicationNumber: 1,
  NVCMatterNumber: 2,
  PERMReceipt: 3,
  Other: 4
}

export const MatterReceiptTypeList: EnumOption[] = [
    { value: MatterReceiptType.USCISReceiptNumber, label: 'USCIS Receipt Number' },
    { value: MatterReceiptType.JVisaApplicationNumber, label: 'J Visa Application Number' },
    { value: MatterReceiptType.NVCMatterNumber, label: 'NVC Matter Number' },
    { value: MatterReceiptType.PERMReceipt, label: 'PERM Receipt' },
    { value: MatterReceiptType.Other, label: 'Other' },
]
